<template>
  <div class="">
    <h1>{{ msg }}</h1>
    <p>powered by Google resonance</p>

    <div class="soundContainer d-flex flex-column align-start">
        <h4 class="title">Playback audio track</h4>

        <audio id="song" src="/static/sounds/Clap Clap - Flowing Like a Snake in Ophiuchus Arms.mp3" controls />

        <h4>XYZ Settings</h4>

        <label for="X" >X (left-right): {{sourcePosition.x}} </label>
        <input v-model="sourcePosition.x"  id="X" type="range" min="-5" max="5" step="0.001" />

        <label for="Y" >Y (back-forward): {{sourcePosition.y}} </label>
        <input v-model="sourcePosition.y"  id="Y" type="range" min="-5" max="5" step="0.001" />

        <label for="Z" >Z (low-high): {{sourcePosition.z}} </label>
        <input v-model="sourcePosition.z"  id="Z" type="range" min="-5" max="5" step="0.001" /> 
    </div>
    

  </div>
</template>

<script>
import { ResonanceAudio } from 'resonance-audio';

export default {
  name: 'Spatial',
  data() {
    return {
      msg: 'Spatial playground',
      mediaStreamSource: null,

      audioContext: null,

      // google resonance
      resonanceAudioScene: null,
      source: null,
      sourcePosition: {
        x: -0.707,
        y: -0.707,
        z: 0,
      },
      room: {
        // sizes in meters (m)
        dimensions: {
          width: 3.1,
          height: 2.5,
          depth: 3.4,
        },
        // for rooms 6 walls
        materials: {
          left: 'brick-bare',
          right: 'brick-bare',
          front: 'brick-bare',
          back: 'brick-bare',
          down: 'grass', // floor
          up: 'transparent', // ceiling
        },
      },
    };
  },
  mounted() {
    this.setupAudio();
  },
  watch: {
    sourcePosition: {
      handler() {
        this.updateSourcePosition();
      },
      deep: true,
    },
  },
  methods: {
    setupAudio() {
      // get webaudio
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      // create audio context
      this.audioContext = new AudioContext();
      // Create a (first-order Ambisonic) Resonance Audio scene and pass it the AudioContext.
      this.resonanceAudioScene = new ResonanceAudio(
        this.audioContext,
        { ambisonicOrder: 3 }, // 3rd order ambisonics sounds rad
      );
      // Connect the scene’s binaural output to stereo out.
      this.resonanceAudioScene.output.connect(this.audioContext.destination);
      // Add the room definition to the scene.
      this.resonanceAudioScene.setRoomProperties(this.room.dimensions, this.room.materials);

      /* sound setup */
      // Create an AudioElement or grab one from the DOM
      // const audioElement = document.createElement('audio');
      const audioElement = document.querySelector('#song');
      // Generate a MediaElementSource from the AudioElement.
      const audioElementSource = this.audioContext.createMediaElementSource(audioElement);
      // Add the MediaElementSource to the scene as an audio input source.
      this.source = this.resonanceAudioScene.createSource();
      audioElementSource.connect(this.source.input);
      // Set the source position relative to the room center (source default position).
      this.source.setPosition(
        this.sourcePosition.x,
        this.sourcePosition.y,
        this.sourcePosition.z,
      );
    },
    updateSourcePosition() {
      this.source.setPosition(
        this.sourcePosition.x,
        this.sourcePosition.y,
        this.sourcePosition.z,
      );
    },
  },
};
</script>

<style scoped>
.soundContainer {
    border: 1px solid grey;
    width: fit-content;
    margin: 40px auto; 
    padding: 20px;
}
.soundContainer input {
    width: 100%;
}
.soundContainer .title {
    background: #fff;
    margin-top: -30px;
    padding: 0 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Spatial.vue